import React, { useCallback } from "react";
import { styled, css } from "styled-components";
import { Badge } from "components/bootstrap";
import Routes from "routing/Routes";
import { Link } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { DELETED_STREAM_TITLE } from "data-lake/Constants";
import { COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
const RetrievedStatusBadge = styled(Badge)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.xxs};
  `
);
const INTERNAL_DATA_LAKE_LABEL = "Internal Data Lake";
const StreamTitleCell = ({ streamId, streamTitle }) => {
  const sendTelemetry = useSendTelemetry();
  const handleClick = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.RETRIEVALS.SHOW_MESSAGES_BUTTON_CLICKED, {});
  }, [sendTelemetry]);
  return /* @__PURE__ */ React.createElement(Link, { to: `${Routes.stream_view(streamId)}?segment=destinations`, onClick: handleClick }, streamTitle);
};
const customColumnRenderers = {
  attributes: {
    username: {
      staticWidth: COLUMN_WIDTH.user
    },
    status: {
      renderCell: (status) => /* @__PURE__ */ React.createElement(RetrievedStatusBadge, { bsStyle: status === "COMPLETE" ? "success" : "warning" }, status),
      staticWidth: 110
    },
    source_name: {
      renderCell: (source_name, entity) => entity.type === "ICEBERG" ? INTERNAL_DATA_LAKE_LABEL : source_name
    },
    stream_title: {
      renderCell: (stream_title, entity) => stream_title ? /* @__PURE__ */ React.createElement(StreamTitleCell, { streamId: entity.stream_id, streamTitle: stream_title }) : DELETED_STREAM_TITLE
    },
    restore_indices: {
      renderCell: (restore_indices) => /* @__PURE__ */ React.createElement(React.Fragment, null, restore_indices.length),
      staticWidth: "matchHeader"
    },
    retrieved_documents: {
      staticWidth: "matchHeader"
    },
    index_failures: {
      staticWidth: "matchHeader"
    },
    type: {
      staticWidth: 80
    }
  }
};
export default customColumnRenderers;
